import React from "react";
import { Theme } from "../types/types";
import { useTheme } from "../contexts/ThemeContext";

interface ThemeToggleProps {
  theme: Theme;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ theme }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      style={{
        backgroundColor: theme.surface,
        color: theme.text,
        border: `1px solid ${theme.border}`,
        borderRadius: "6px",
        padding: "6px 12px",
        cursor: "pointer",
        fontSize: "16px",
      }}
    >
      {isDark ? "☀️" : "🌙"}
    </button>
  );
};
